export const readReportRows = async (ready: Response): Promise<string[] | null> => {
    const blob = await ready.blob()
    const text = await blob.text()

    if (text.length < 1) return null

    const rows = text.split('\n')
    if (rows.length < 2) return null

    return rows
}

export const parseCSVRow = (row: string): string[] => {
    const result: string[] = []
    let inQuotes = false
    let current = ''

    for (let i = 0; i < row.length; i++) {
        const char = row[i]
        if (char == '"') {
            inQuotes = !inQuotes
        } else if (char == ',' && !inQuotes) {
            result.push(current)
            current = ''
        } else {
            current += char
        }
    }

    result.push(current)
    return result
}


// WEBPACK FOOTER //
// ./src/component/app/report/reportCsv.ts